App.edugram = {
    EDUGRAM_RECl: 86177,
    EDUGRAM_COOKIE: App.cookie.get('edugram_visit'),

    /**
     * Runner
     */
    run: function () {
        return this.saveEdugramFirstVisit();
    },

    /**
     * Сохраняем первый визит эдуграма в куку
     * @returns {boolean}
     */
    saveEdugramFirstVisit: function () {
        this.modifyUrlParamsForTl();
        var queryParams = App.queryString;

        if (queryParams.hasOwnProperty('recl') && queryParams.hasOwnProperty('edugram_id')) {
            queryParams.recl = parseInt(queryParams.recl);
            //проверяем что код рекламы 5 знаков и он точно принадлежит edugram
            if (queryParams.recl >= 9999 && queryParams.recl == this.EDUGRAM_RECl) {

                // удаляем куку с партнерами, если она есть
                if (App.cookie.get('partners_lead_visit')) {
                    App.cookie.set('partners_lead_visit', '', {expires: -1});
                }

                // сохраняем все в куки
                const PARTNERS_COOKIE_NAME = 'edugram_visit';
                const PARTNERS_COOKIE_STORE_DAYS = 30;

                App.cookie.set(
                    PARTNERS_COOKIE_NAME,
                    JSON.stringify(queryParams),
                    {expires: PARTNERS_COOKIE_STORE_DAYS * 60 * 60 * 24}
                );
                console.log('EDUGRAM: First visit params saved');
                return true;
            }
        }
        return false;
    },

    /**
     * Изменяем параметры url в заказе пробного урока из куки
     */
    modifyUrlParamsForTl: function () {
        if  (document.getElementsByName('orderForm').length > 0) {
            return false;
        }

        var urlParams = document.querySelector('#urlParameters');
        if (
            urlParams !== null && App.queryString.edugram_id === undefined
            && (
                this.EDUGRAM_COOKIE !== undefined
                && this.EDUGRAM_COOKIE != ''
                && App.cookie.get('channel_code') == JSON.parse(this.EDUGRAM_COOKIE).recl
            )
        ) {
            var newUrlParams = JSON.stringify($.extend(JSON.parse(urlParams.value), JSON.parse(this.EDUGRAM_COOKIE)));
            //console.log('Input: ' + urlParams.value)
            //console.log('Кука: ' + this.EDUGRAM_COOKIE)
            //console.log('Вместе: ' + newUrlParams)

            urlParams.value = newUrlParams

        }
    }


};

/**
 * RUN
 */
window.onload = function() {
    App.edugram.run()
};

